import React, { useState } from 'react';
import EditOrderModal from './EditOrderModal';
import { OrderSearch, useOrderDates, orderDateLabel, sectionStyle, actionButtonStyle } from './PastOrderSearch';

// Start a new order from a previous one, so a repeat order doesn't have to
// be re-entered by hand. Unlike RestoreOrder (which brings an old order
// back exactly as it was), this opens the order form pre-filled from the
// past order so the admin can adjust anything first, validates it like any
// new order, and can send the parent a confirmation email.
function CopyOrder({ apiBase, onCopied }) {
  const { orderDates, selectedId, error } = useOrderDates(apiBase);
  const [source, setSource] = useState(null);

  return (
    <div style={sectionStyle}>
      <h3 style={{margin: '0 0 0.5rem 0'}}>Copy a Previous Order</h3>
      <div style={{fontSize: '0.9rem', color: '#666', marginBottom: '1rem'}}>
        Make a new order from a previous one instead of re-entering it by hand. Search all orders, including deleted
        ones, by reference number or name, then review or adjust the details and pick the order date.
      </div>
      {error && <div style={{color: '#dc3545', marginBottom: '1rem'}}>{error}</div>}

      <OrderSearch
        apiBase={apiBase}
        renderAction={o => (
          <button onClick={() => setSource(o)} style={actionButtonStyle(false)}>
            Copy…
          </button>
        )}
      />

      {source && (
        <EditOrderModal
          mode="copy"
          apiBase={apiBase}
          order={source}
          orderDates={orderDates}
          defaultOrderDateId={selectedId}
          onClose={() => setSource(null)}
          onSaved={(created) => {
            setSource(null);
            const date = orderDates.find(d => d.id === created.order_date_id);
            const emailNote = created.email_sent ? ' A confirmation email was sent.' : '';
            alert(`Created order ${created.reference_number}${date ? ` for ${orderDateLabel(date)}` : ''}.${emailNote}`);
            onCopied?.();
          }}
        />
      )}
    </div>
  );
}

export default CopyOrder;
